import { Col, Layout, Row, Space } from 'antd';
import ViolationTable from '../Roster/ViolationTable';
import type { UserFatigueViolationReport } from '../../hooks/types';
import type { RosterTableRowRecord, ShiftPeriod } from './types';
import { shiftBackgroundColours } from '../../theme';

type ShiftViolationDisplay = {
  readonly usersFatigueReport?: readonly UserFatigueViolationReport[];
  readonly rosterShiftsRecords: readonly RosterTableRowRecord[];
  readonly dayShiftPeriod: ShiftPeriod | undefined;
};

/**
 * Renders the shifts and fatigue violations for a roster.
 * @returns A laid out table for display
 */
const ShiftViolationDisplay = ({
  usersFatigueReport,
  dayShiftPeriod,
  rosterShiftsRecords,
}: ShiftViolationDisplay) => (
  <Layout>
    <Row>
      <Col span={24}>
        <Space style={{ float: 'right' }}>
          {['OK', 'Fatigue Issue'].map((period, i) => {
            return (
              <Space key={i}>
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    backgroundColor:
                      period === 'OK'
                        ? shiftBackgroundColours.vacantDay
                        : shiftBackgroundColours.violation,
                    border: '1px solid black',
                  }}
                />
                {period}
              </Space>
            );
          })}
        </Space>
      </Col>
      <Col span={24}>
        <ViolationTable
          usersFatigueReport={usersFatigueReport}
          loading={false}
          rosterShiftsRecords={rosterShiftsRecords}
          rosterPaginationSetting={false}
          dayShiftPeriod={dayShiftPeriod}
        />
      </Col>
    </Row>
  </Layout>
);

export default ShiftViolationDisplay;
